import { render, staticRenderFns } from "./TheFooterNavbarButton.vue?vue&type=template&id=351fc5b9&"
import script from "./TheFooterNavbarButton.vue?vue&type=script&lang=js&"
export * from "./TheFooterNavbarButton.vue?vue&type=script&lang=js&"
import style0 from "./TheFooterNavbarButton.vue?vue&type=style&index=0&id=351fc5b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports